// Printing helper.
//
// Browsers and "Print to PDF" drivers take the suggested save-as name (and the
// text in the page header) from document.title, which is just "Ticketing
// System" for the whole app. Each print sets a meaningful name for the
// duration of the print job and restores the old one afterwards.

export function printWithFileName(name) {
  var previous = document.title;
  var restored = false;
  var restore = function () {
    if (restored) return;
    restored = true;
    document.title = previous;
    window.removeEventListener("afterprint", restore);
  };

  // Browsers disallow "/" and friends in a download name; keep it tidy.
  document.title = String(name || previous).replace(/[\\/:*?"<>|]+/g, "-");
  window.addEventListener("afterprint", restore);
  try {
    window.print();
  } finally {
    // afterprint doesn't fire everywhere (and never in some older browsers),
    // so the title is put back on a timer as well.
    setTimeout(restore, 1000);
  }
}
